import { ReactNode } from "react";
import { BackgroundContainer } from "./Authentication.styles";
import AuthFooter from "./AuthFooter";

interface Props {
  children: ReactNode;
}

export default function AuthenticationLayout({ children }: Props) {
  return (
    <>
      <BackgroundContainer>
        {children}
      </BackgroundContainer>
      <AuthFooter />
    </>
  );
}
